import { datadogRum } from '@datadog/browser-rum';

export const trackDatadogFeatureFlagEvaluation = (name: string, value: unknown) => {
  datadogRum.addFeatureFlagEvaluation(name, value);
};
